module.exports = {
        srcSet: __webpack_public_path__ + "efc626f3b9fdbaba-350.png"+" 350w",
        images: [{path: __webpack_public_path__ + "efc626f3b9fdbaba-350.png",width: 350,height: 250}],
        src: __webpack_public_path__ + "efc626f3b9fdbaba-350.png",
        toString: function(){return __webpack_public_path__ + "efc626f3b9fdbaba-350.png"},
        
        width: 350,
        height: 250
      }